import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { SearchItemOperator } from '@Types/api/common/filters';
import { TypeDict } from '@Types/index';

import { LanguageCodes } from '../languages';
import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  dateFrom: '',
  dateTo: '',
  purpose: [],
  requiredLanguage: [],
  statuses: [],
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  dateFrom: 'ge',
  dateTo: 'le',
  purpose: 'in',
  requiredLanguage: 'in',
  statuses: 'in',
};

export const getFiltersMapper =
  (statuses: TypeDict[], salaryTypeOptions: TypeDict[]): Mapper =>
  (key, value) => {
    if (key === 'dateFrom') {
      return ['startDate', value];
    }

    if (key === 'dateTo') {
      return ['startDate', value];
    }

    if (key === 'purpose') {
      const purposeCodes = (value as string[]).map(
        (item) =>
          salaryTypeOptions.find((salaryType) => salaryType.codeDesc === item)!
            .codeNum
      );
      return ['leaveTypeID', purposeCodes];
    }

    if (key === 'requiredLanguage') {
      const languagesResultValue = (value as string[]).map(
        (item) => LanguageCodes[item as keyof typeof LanguageCodes]
      );
      return ['destination', languagesResultValue];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['reqStatusId', statusResultValue];
  };
